@if (!isDismissed()) {
  <div class="sunset-overlay">
    <div class="sunset-modal">
      <div class="sunset-modal-icon">
        <lucide-icon [img]="AlertTriangle" [size]="36" />
      </div>
      <h2 class="sunset-modal-title">Terlumina has moved</h2>
      <p class="sunset-modal-body">
        This environment has been replaced. Please visit the new site to complete your tasks.
      </p>
      <p class="sunset-modal-help">
        For issues, contact your local site admin or submit an SLHS ticket for assistance.
      </p>
      <div class="sunset-modal-actions">
        <a
          class="sunset-modal-btn sunset-modal-btn--primary"
          href="https://slhs.xqworkflow.com/"
          target="_blank"
        >
          Take me to the new site
        </a>
        <button class="sunset-modal-btn sunset-modal-btn--ghost" (click)="dismissBanner()">
          Continue to old environment
        </button>
      </div>
    </div>
  </div>
}
